module.exports = __webpack_public_path__ + "static/media/check.4b47aefd.svg";